import React, { useRef } from 'react'

interface ClampTextProps {
  children: React.ReactNode
  clamp: number
  className?: string
  style?: React.CSSProperties
}

const ClampText: React.FC<ClampTextProps> = ({ children, clamp, className = '', style = {} }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: clamp,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default ClampText
